<ng-container *ngIf="name" [formGroup]="form">
    <p>{{ label }} <span *ngIf="required">*</span></p>
    <mat-form-field appearance="none" class="manage-input" >
        <input
            matInput
            required="{{ required || false }}"
            formControlName="{{name}}"
            [placeholder]="placeholder ? placeholder : 'Enter' + ' ' + name"
            [type]="type ? type : 'text'"
            pattern="{{pattern ? pattern.toString() : ''}}"
            minlength="{{minlength ? minlength :''}}"
            maxlength="{{maxlength ? maxlength :''}}"
            (input)="checkErrors()"
            (blur)="checkErrors()"
            (keypress)="triggerKeypress($event)"
        />
    </mat-form-field>
    <mat-error
        *ngFor="let error of errors"
        class="pl-2 pt-2">
        {{ error.message }}
    </mat-error>
</ng-container>